// Reações: no banco, cada reação é uma linha de mensagem (mediaType "reactionMessage") com o
// emoji no corpo e a mensagem-alvo em quotedMsgId. Aqui elas deixam de ser bolha e viram os
// selinhos da mensagem-alvo.

export const QUICK_REACTIONS = ["👍", "❤️", "😂", "😮", "😢", "🙏"];

export const isReactionRow = (message) => !!message && message.mediaType === "reactionMessage";

// "❤️" e "❤" são o mesmo emoji (com e sem seletor de variação)
export const sameEmoji = (a, b) =>
  String(a || "").replace(/️/g, "") === String(b || "").replace(/️/g, "");

// corpo vazio = a pessoa removeu a reação ("reaction" era o marcador antigo do servidor para isso)
const emojiOf = (row) => {
  const body = String(row.body == null ? "" : row.body).trim();
  return body === "reaction" ? "" : body;
};

const authorOf = (row) => {
  if (row.fromMe) return "me";
  const who = (row.contact && row.contact.id) || row.contactId || row.participant || "contato";
  return `c:${who}`;
};

const targetOf = (row) => {
  if (row.quotedMsgId !== undefined && row.quotedMsgId !== null && row.quotedMsgId !== "") return row.quotedMsgId;
  return row.quotedMsg && row.quotedMsg.id != null ? row.quotedMsg.id : null;
};

const timeOf = (row) => {
  const t = new Date(row.createdAt).getTime();
  return Number.isNaN(t) ? 0 : t;
};

// Devolve Map(idDaMensagem -> { items: [{ emoji, count, mine, names }], mine, total }).
// Vale a última reação de cada autor; reação cujo alvo não está em `messages` é ignorada.
export const aggregateReactions = (rows, messages) => {
  const result = new Map();
  if (!Array.isArray(rows) || rows.length === 0 || !Array.isArray(messages)) return result;

  // o alvo pode vir como id da mensagem ou como id do WhatsApp (wid)
  const canonical = new Map();
  messages.forEach((m) => {
    if (m == null || m.id == null) return;
    canonical.set(String(m.id), m.id);
    if (m.wid) canonical.set(String(m.wid), m.id);
  });

  const perTarget = new Map();
  rows
    .map((row, order) => ({ row, order }))
    .sort((a, b) => timeOf(a.row) - timeOf(b.row) || a.order - b.order)
    .forEach(({ row }) => {
      const raw = targetOf(row);
      if (raw === null) return;
      const id = canonical.get(String(raw));
      if (id === undefined) return;
      let authors = perTarget.get(id);
      if (!authors) {
        authors = new Map();
        perTarget.set(id, authors);
      }
      const author = authorOf(row);
      const emoji = emojiOf(row);
      authors.delete(author);
      if (emoji) authors.set(author, { emoji, name: row.fromMe ? null : (row.contact && row.contact.name) || null });
    });

  perTarget.forEach((authors, id) => {
    if (authors.size === 0) return;
    const groups = [];
    authors.forEach((reaction, author) => {
      let group = groups.find((g) => sameEmoji(g.emoji, reaction.emoji));
      if (!group) {
        group = { emoji: reaction.emoji, count: 0, mine: false, names: [] };
        groups.push(group);
      }
      group.count += 1;
      if (author === "me") group.mine = true;
      else if (reaction.name) group.names.push(reaction.name);
    });
    const mine = authors.get("me");
    result.set(id, { items: groups, mine: mine ? mine.emoji : null, total: authors.size });
  });

  return result;
};
